<template>
  <div class="upload">
    <!--    <el-button size="mini" :type="btn_type" @click="uploadVisible = true">上传图片</el-button>-->
    <el-button size="mini"
               :type="btn_type"
               @click="uploadVisible = true">{{text}}</el-button>
    <el-dialog title="上传图片"
               :visible.sync="uploadVisible"
               :modal="false"
               width="40%">
      <el-upload class="upload-demo"
                 accept="png,jpg,jpeg"
                 ref="upload"
                 :multiple="false"
                 :limit="limit"
                 :http-request="postImg"
                 :action="uploadUrl"
                 :on-change="onChange"
                 :file-list="fileList"
                 :auto-upload="false"
                 list-type="picture">
        <span slot="trigger"
              class="btn">选取文件</span>
        <span @click="submitUpload"
              class="btn btn2">上传到服务器</span>
        <div slot="tip"
             class="el-upload__tip"
             style="margin-top:0.2rem;">只能上传{{img_size}}大小的文件</div>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'hsUpload',
  data() {
    return {
      uploadVisible: false,
      uploadBool: false,
      fileList: []
    }
  },
  props: {
    limit: { // 上传数量限制
      default() {
        return 1
      },
      type: Number
    },
    text: {
      default() {
        return '...'
      },
      type: String
    },
    uploadAPI: {}, // 上传API
    uploadIndex: null,
    param: {}, // 问号参数
    img_types: { // 图片格式要求
      default() {
        return ['jpg', 'png', 'jpeg']
      },
      type: Array
    },
    img_size: { // 图片大小要求
      default() {
        return '500kb'
      },
      type: String
    },
    btn_type: {
      default() {
        return 'primary'
      },
      type: String
    }
  },
  computed: {
    uploadUrl() {
      return `1`
    },
    img_types_str() {
      let str = ''
      this.img_types.map(item => {
        if (str) {
          str += `/${item}`
        } else {
          str += `${item}`
        }
      })
      return str
    }
  },
  methods: {
    onChange(file, fileList) {
      this.fileList = fileList
    },
    // 上传图片到本地
    postImg() {
      const formData = new FormData()
      // formData.append('file', content.file)
      this.fileList.forEach(item => {
        formData.append(`file`, item.raw)
      })
      if (!this.uploadBool) {
        this.uploadBool = true
        // const routerParams = {
        //   user_id: this.bill_query_one_detail.id
        // }
        let url = ''
        let paramStr = ''
        if (this.uploadAPI) {
          if (this.param) {
            for (const key in this.param) {
              if (paramStr) {
                paramStr += `&${key}=${this.param[key]}`
              } else {
                paramStr += `?${key}=${this.param[key]}`
              }
            }
          }
          url = this.uploadAPI + paramStr
          this.$API.post(url, formData).then(res => {
            // this.uploadScuccess(res.data)
            this.$message({
              type: 'success',
              message: '上传成功!'
            })
            if (this.uploadIndex !== null) {
              console.log(this.uploadIndex)
              const obj1 = {
                fileName: res.data[0].NewFileName,
                uploadIndex: this.uploadIndex
              }
              this.$emit('fileName', obj1)
            } else {
              console.log(1)
              this.$emit('fileName', res.data[0].NewFileName)
            }

            this.fileList = []
            this.uploadVisible = false
          })
        }
      }
    },
    // 上传图片
    submitUpload() {
      this.uploadBool = false
      this.$refs.upload.submit()
    }
  }
}
</script>
<style scoped>
.upload {
  display: inline-block;
  width: auto;
}
.btn {
  cursor: pointer;
  background: #409eff;
  color: #fff;
  padding: 4px 12px;
  border-radius: 3px;
}
.btn2 {
  background: rgb(19, 206, 102);
}
</style>



// WEBPACK FOOTER //
// src/components/upload/index.vue